<template>
  <mdb-container>
    <mdb-card>
      <mdb-card-header class="pt-4 indigo">
        <mdb-card-title class="text-white">
          <strong>{{ $t("bug_reports") }}</strong>
        </mdb-card-title>
      </mdb-card-header>
      <mdb-card-body>
        <DataTableAG
          :columns="columns"
          getcontentpath="1.0/front/bugreports"
          jsonobject="issues"
          width="100%"
          height="600px"
        />
      </mdb-card-body>
    </mdb-card>
  </mdb-container>
</template>

<script>
import {
  mdbContainer,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardTitle,
} from "mdbvue";
import DataTableAG from "@/components/DataTableAG.vue";

export default {
  name: "BugReports",
  components: {
    mdbContainer,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardTitle,
    DataTableAG,
  },
  data() {
    return {
      columns: [
        {
          headerName: this.$t("bug_key"),
          field: "key",
          width: 130,
          sortable: true,
          filter: true,
        },
        {
          headerName: this.$t("bug_title"),
          field: "summary",
          flex: 1,
          minWidth: 300,
          wrapText: true,
          autoHeight: true,
          cellStyle: { "white-space": "normal", "line-height": "1.4" },
          sortable: true,
          filter: true,
        },
        {
          headerName: this.$t("bug_status"),
          field: "status",
          width: 160,
          sortable: true,
          filter: true,
        },
        {
          headerName: this.$t("bug_labels"),
          field: "labels",
          width: 220,
          valueFormatter: (p) => (p.value || []).join(", "),
          sortable: true,
          filter: true,
        },
        {
          headerName: this.$t("bug_created"),
          field: "created",
          width: 140,
          valueFormatter: (p) => (p.value ? p.value.substring(0, 10) : ""),
          sortable: true,
          filter: true,
        },
        {
          headerName: this.$t("bug_last_comment"),
          field: "lastComment",
          flex: 1,
          minWidth: 250,
          wrapText: true,
          autoHeight: true,
          cellStyle: { "white-space": "normal", "line-height": "1.4" },
          sortable: true,
          filter: true,
        },
      ],
    };
  },
};
</script>
